import { useTypedSelector } from '@Features/store';
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';
import { assignmentsGetSingle } from '../../Slices/Assignment.Slice';
import EditAssignmentInfo from './EditAssignmentInfo';
import { useUnitPermissions } from '@Pages/ClassRooms/Pages/SingleCourse/Pages/CourseForm/Pages/CourseContent/useUnitPermissions';

const EditAssignment = () => {
	const { id } = useParams<{ id: string }>();
	const dispatch = useDispatch();

	const {
		currentEntity,
		loaders: { getSingle },
	} = useTypedSelector((state) => state.Assignments);
	const { canUpdate } = useUnitPermissions();
	const history = useHistory();

	useEffect(() => {
		if (!canUpdate) {
			history.goBack();
			return;
		}
		dispatch(assignmentsGetSingle({ id: Number(id) }));
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	if (!canUpdate) return null;

	return (
		<>{currentEntity && getSingle === 'fulfilled' && <EditAssignmentInfo />}</>
	);
};

export default EditAssignment;
